























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SystemApi, ValueListItem } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    sys: 'systemApi'
  })
})
export default class jobPriorityPicker extends Vue {
  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Priority' })
  private labelOverride?: string;

  get selectedValue() {
    return this.value;
  }
  set selectedValue(value: string) {
    this.$emit('input', value);
  }

  private sys!: SystemApi;

  jobPriorities: ValueListItem[] = [];

  get jobPrioritiesSorted() {
    if (!this.jobPriorities) {
      return null;
    }
    return this.jobPriorities.sort((a, b) => {
      if (a.valueListValue && b.valueListValue) {
        return a.valueListValue.localeCompare(b.valueListValue);
      }
      return 0;
    });
  }

  @Watch('propertyId')
  private async loadjobPriorities() {
    if (!this.propertyId) return; // can't load without propertyId
    this.jobPriorities = [];
    this.jobPriorities = await this.sys.getJobPriorities({
      propertyId: this.propertyId
    });
  }

  private async mounted() {
    this.loadjobPriorities();
  }
}
